import {
  IconCancel,
  IconGlobe,
  IconRocket,
  IconSeo,
  IconUser,
  IconHome,
  IconPhoneCall,
  IconCalendar,
  IconArrowBack,
  IconPlane, // For forward shipments
  IconBuildingWarehouse, // For warehouse
  IconShoppingCart, // For abandon cart
  IconList, // For all shipments
  IconCash, // For purchase
  IconFiles, // For resources
  IconPhoto, // For S3 Explorer
} from '@tabler/icons-react';

const MenuIcon = ({ children }: { children: React.ReactNode }) => (
  <span className="group-hover:!text-primary shrink-0">{children}</span>
);

export const menuItems = [
  {
    title: 'Manage Shipments',
    submenu: [
      {
        title: 'Reverse Shipments',
        icon: (
          <MenuIcon>
            <IconArrowBack />
          </MenuIcon>
        ),
        link: '/reverse-shipments',
      },
      {
        title: 'Forward Shipments',
        icon: (
          <MenuIcon>
            <IconPlane />
          </MenuIcon>
        ),
        link: '/forward-shipments',
      },
      {
        title: 'All Shipments',
        icon: (
          <MenuIcon>
            <IconList />
          </MenuIcon>
        ),
        link: '/all-shipments',
      },

      {
        title: 'Shipment Booking',
        icon: (
          <MenuIcon>
            <IconCalendar />
          </MenuIcon>
        ),
        link: '/shipment-booking',
      },

      {
        title: 'Check Address Availability',
        icon: (
          <MenuIcon>
            <IconGlobe />
          </MenuIcon>
        ),
        link: '/check-availability',
      },
      {
        title: 'Schedule',
        icon: (
          <MenuIcon>
            <IconCalendar />
          </MenuIcon>
        ),
        link: '/schedule-shipment',
      },
    ],
  },
  {
    title: 'Management',
    submenu: [
      {
        title: 'Missed Calls',
        icon: (
          <MenuIcon>
            <IconPhoneCall />
          </MenuIcon>
        ),
        link: '/missed-calls',
      },
      {
        title: 'Abandoned Cart',
        icon: (
          <MenuIcon>
            <IconShoppingCart />
          </MenuIcon>
        ),
        link: '/ab-cart',
      },
      {
        title: 'SEO Content',
        icon: (
          <MenuIcon>
            <IconSeo />
          </MenuIcon>
        ),
        link: '/seo-contents',
      },
      {
        title: 'Invalid Domains',
        icon: (
          <MenuIcon>
            <IconGlobe />
          </MenuIcon>
        ),
        link: '/invalid-domains',
      },
      {
        title: 'Defaulters',
        icon: (
          <MenuIcon>
            <IconCancel />
          </MenuIcon>
        ),
        link: '/defaulters',
      },
    ],
  },

  {
    title: 'Admin',
    submenu: [
      {
        title: 'Users',
        icon: (
          <MenuIcon>
            <IconUser />
          </MenuIcon>
        ),
        link: '/users',
      },
      {
        title: 'Roles',
        icon: (
          <MenuIcon>
            <IconRocket />
          </MenuIcon>
        ),
        link: '/roles',
      },
      {
        title: 'Resources',
        icon: (
          <MenuIcon>
            <IconFiles />
          </MenuIcon>
        ),
        link: '/resources',
      },
    ],
  },
  {
    title: 'Apps',
    submenu: [
      {
        title: 'S3 Explorer',
        icon: (
          <MenuIcon>
            <IconPhoto />
          </MenuIcon>
        ),
        link: '/s3explorer',
      },
      {
        title: 'Calendar',
        icon: (
          <MenuIcon>
            <IconCalendar />
          </MenuIcon>
        ),
        link: '/calendar',
      },
    ],
  },
];
